import React, { MouseEventHandler, ReactNode } from "react";
import { SupText } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface UiDetailsAtomSingleLinkProps {
  className?: string;
  title?: string;
  icon?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

export default function UiDetailsAtomSingleLink({ className, title, icon, onClick }: UiDetailsAtomSingleLinkProps) {
  return (
    <div
      className={twMerge(
        "z-10 flex h-10 min-w-10 items-center justify-center gap-2 border-0.5 border-neutral-1000 bg-primary-25 px-2 text-neutral-1000 transition-colors duration-200 hover:bg-primary-50",
        onClick && "cursor-copy",
        className
      )}
      onClick={onClick}
    >
      {title && (
        <SupText as="div" variant="button" className="mx-2 hidden md:block">
          {title}
        </SupText>
      )}
      {icon}
    </div>
  );
}
